<template>
  <section class="eventos-wrapper">
    <!-- CEREMONIA -->
    <div class="evento-card" ref="ceremoniaRef">
      <p class="hora" ref="hora1">3:00 PM</p>
      <p class="titulo" ref="titulo1">Ceremonia</p>

      <img src="@/assets/igle.avif" class="icono" ref="icono1" />

      <p class="lugar" ref="lugar1">Iglesia Jesucristo Es El Camino    </p>
      <p class="direccion" ref="dir1">
      10971 Atomic Rd North Augusta <br>SC 29841
      </p>

      <a href="https://maps.app.goo.gl/QjvnZpq2tizGCjTZ7" target="_blank" class="btn-mapa" ref="btn1">
        ¡Google Maps!
      </a>
    </div>

    <!-- CELEBRACIÓN -->
    <div class="evento-card" ref="celebracionRef">
      <p class="hora" ref="hora2">5:30 PM</p>
      <p class="titulo" ref="titulo2">Celebración</p>

      <img src="@/assets/cele.avif" class="icono" ref="icono2" />

      <p class="lugar" ref="lugar2">Phinizy House Events Center
</p>
      <p class="direccion" ref="dir2">
      529 Greene St
        Augusta <br>  GA 30901.
      </p>

      <a href="https://maps.app.goo.gl/zLSTBAG4A2A6G5jA6" target="_blank" class="btn-mapa" ref="btn2">
        ¡Google Maps!
      </a>
    </div>
  </section>
</template>
<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventosElegantes',
  setup() {
    const refs = {}
    ;[
      'ceremoniaRef','celebracionRef',
      'hora1','titulo1','icono1','lugar1','dir1','btn1',
      'hora2','titulo2','icono2','lugar2','dir2','btn2'
    ].forEach(r => refs[r] = ref(null))

    onMounted(() => {

      const preparar = (els) => {
        gsap.set([
          els.hora,
          els.titulo,
          els.icono,
          els.lugar,
          els.dir,
          els.btn
        ], { opacity: 0 })

        gsap.set(els.hora,   { y: -60 })
        gsap.set(els.titulo, { y: 60 })
        gsap.set(els.icono,  { y: -80 })
        gsap.set(els.lugar,  { x: -80 })
        gsap.set(els.dir,    { x: 80 })
        gsap.set(els.btn,    { y: 60 })
      }

      const animar = (card, els) => {
        preparar(els)

        gsap.timeline({
          scrollTrigger: {
            trigger: card,
            start: 'top 80%',
            toggleActions: 'play none none none',
            once: true
          },
          defaults: {
            ease: 'power2.out'
          }
        })
        .to(els.hora,   { y: 0, opacity: 1, duration: 0.5 })
        .to(els.titulo, { y: 0, opacity: 1, duration: 0.5 }, '-=0.3')
        .to(els.icono,  { y: 0, opacity: 1, duration: 0.6 }, '-=0.35')
        .to(els.lugar,  { x: 0, opacity: 1, duration: 0.5 })
        .to(els.dir,    { x: 0, opacity: 1, duration: 0.5 }, '-=0.3')
        .to(els.btn,    { y: 0, opacity: 1, duration: 0.45 })
      }

      animar(refs.ceremoniaRef.value, {
        hora: refs.hora1.value,
        titulo: refs.titulo1.value,
        icono: refs.icono1.value,
        lugar: refs.lugar1.value,
        dir: refs.dir1.value,
        btn: refs.btn1.value
      })

      animar(refs.celebracionRef.value, {
        hora: refs.hora2.value,
        titulo: refs.titulo2.value,
        icono: refs.icono2.value,
        lugar: refs.lugar2.value,
        dir: refs.dir2.value,
        btn: refs.btn2.value
      })

      ScrollTrigger.refresh()
    })

    return refs
  }
}

</script>

<style scoped>
.eventos-wrapper {
  background-color: rgba(217, 212, 209, 0.95);
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;              /* 🔴 YA NO SE VE SEPARADO */
  align-items: center;
}

.evento-card {
  width: 100%;
  max-width: 360px;
  min-height: 600px;     /* 🔴 más compacto visualmente */
  text-align: center;
  color: #8a6a3f;
  padding: 20px;
}

/* TEXTO */
.hora {
  font-family: 'Playfair Display', serif;
  font-size: 27px;
  margin-bottom: 8px;
}

.titulo {
  font-family: 'Playfair Display', serif;
  font-size: 30px;
  letter-spacing: 2px;
  margin-bottom: 20px;
}

.icono {
  width: 200px;
  margin: 0 auto 22px;
  display: block;
}

.lugar {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  margin-bottom: 6px;
}

.direccion {
  font-family: 'Playfair Display', serif;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 22px;
}

.btn-mapa {
  display: inline-block;
  border: 1px solid #8a6a3f;
  padding: 12px 28px;
  font-family: 'Playfair Display', serif;
  font-size: 13px;
  color: #8a6a3f;
  text-decoration: none;
  letter-spacing: 1px;
}
</style>
